import { type QueryDocumentSnapshot, type SnapshotOptions, Timestamp } from 'firebase/firestore'
import type { MarkOptional, OmitProperties } from 'ts-essentials'

export type AdScriptParams = OmitProperties<MarkOptional<AdScript, 'createdAt' | 'updatedAt'>, Function>

export class AdScript {
  id?: string
  name: string
  contentHtml: string
  productId?: string
  brandId?: string

  // metadata
  createdAt: Date
  updatedAt: Date

  static toFirestore(adScript: AdScript) {
    return {
      id: adScript.id,
      name: adScript.name || '',
      contentHtml: adScript.contentHtml || '',
      productId: adScript.productId || '',
      brandId: adScript.brandId || '',

      createdAt: Timestamp.fromDate(adScript.createdAt),
      updatedAt: Timestamp.fromDate(adScript.updatedAt),
    }
  }

  static fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions): AdScript {
    const data = snapshot.data()

    return new AdScript({
      id: snapshot.id,
      name: data.name || '',
      contentHtml: data.contentHtml || '',
      productId: data.productId || '',
      brandId: data.brandId || '',
      createdAt: data.createdAt ? data.createdAt.toDate() : new Date(),
      updatedAt: data.updatedAt ? data.updatedAt.toDate() : new Date(),
    })
  }

  constructor(data: AdScriptParams) {
    this.name = data.name
    this.contentHtml = data.contentHtml
    this.productId = data.productId
    this.brandId = data.brandId
    this.id = data.id
    this.createdAt = data.createdAt || new Date()
    this.updatedAt = data.updatedAt || new Date()
  }

  toJSON(): AdScriptParams {
    return {
      id: this.id,
      name: this.name || '',
      contentHtml: this.contentHtml || '',
      productId: this.productId || '',
      brandId: this.brandId || '',
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
    }
  }
}
